// @flow

// vendor
// import React from "react";
// import ReactDOM from "react-dom";
// import { Route } from "react-router";
// import { HashRouter } from "react-router-dom";

// utils
import { pubsub, liveBinding } from "@utils/";
import moduleInitializer from "@utils/moduleInitializer";
// import getPropsFromElement from "@utils/getPropsFromElement";
import LazyLoad from "vanilla-lazyload";

// modules/components
import "@modules/googleMapsApi";
import "@modules/pageLoadingState";
import "@modules/gaEvent";
import Lightbox from "@modules/Lightbox";
import Carousel from "@modules/Carousel";
import Tooltip from "@modules/Tooltip";
import ReactForm from "@modules/ReactForm";
import AnimateHeight from "@modules/AnimateHeight";
import scrollTo from "@modules/ScrollTo";
import ExternalLinkHandler from "@modules/ExternalLinkHandler";
import FooterPrimaryLink from "@modules/FooterPrimaryLink";
import NavPrimary from "@modules/NavPrimary";
import Favourite from "@modules/Favourite";
import Scroller from "@modules/Scroller";
import PageTracker from "@modules/PageTracker";
import SidebarPanel from "@modules/SidebarPanel";
import VideoVimeo from "@modules/VideoVimeo";
import Resource from "@modules/Resource";

// set "using-mouse" class for styling focus states for keyboard only
document.querySelector("body").addEventListener("mousedown", function() {
    document.body.classList.add("using-mouse");
});
document.querySelector("body").addEventListener("touchstart", function() {
    document.body.classList.add("using-mouse");
});
document.querySelector("body").addEventListener("keydown", function() {
    document.body.classList.remove("using-mouse");
});

// Lazy Loading
window.lazyLoad = new LazyLoad({
    elements_selector: "img, [data-bg]",
});

// init modules on dom ready
document.addEventListener("DOMContentLoaded", () => {
    // Carousel
    moduleInitializer("[data-nav-primary]", NavPrimary);

    // Scroll to element anchors
    scrollTo();

    // External href/url confirmation
    ExternalLinkHandler();

    // Lightbox
    moduleInitializer("[data-lightbox]", Lightbox);
    liveBinding("click", "[data-lightbox-open]", (el, event) => {
        const lightboxID = el.getAttribute("data-lightbox-open");
        if (lightboxID) {
            pubsub.publish(`open-${lightboxID}`);
        }
    });

    // Carousel
    moduleInitializer("[data-carousel]", Carousel);

    // Tooltip
    moduleInitializer("[data-tooltip]", Tooltip);

    // SidebarPanel
    moduleInitializer("[data-sidebar]", SidebarPanel);

    // Animate Height Init
    moduleInitializer("[data-animate-height]", AnimateHeight);

    // Favourite/saving article Init
    moduleInitializer("[data-favourite]", Favourite);

    // Custom scroller area Init
    moduleInitializer("[data-scroller]", Scroller);

    // Video Player Init
    moduleInitializer("[data-id-vimeo]", VideoVimeo);

    // Resource Click Tracker
    moduleInitializer("[data-track]", Resource);

    // Resource Click Tracker
    moduleInitializer("[data-footer-primary__link]", FooterPrimaryLink);
});

// Window load event
window.addEventListener("load", () => {
    // trigger resize event on load to recalculate js components
    window.dispatchEvent(new CustomEvent("resize"));
});

// On YouTube API loaded event
pubsub.subscribe("youtubeiFrameAPILoaded", () => {});

// Google Maps API loaded event
pubsub.subscribe("googleMapsAPILoaded", () => {
    // React Forms
    moduleInitializer("[data-react-form]", ReactForm);
});

// Track page view after designated timeout (30 seconds)
setTimeout(() => {
    PageTracker();
}, 30000);
